module.exports = new __parcel__URL__("kudos.4785bf39.svg").toString();